import { CompatibilityTableFactory } from './CompatibilityTableFactory.js';
export class CompatibilityTableParser {
    constructor(doc) {
        this.doc = doc;
        this.data = [];
    }
    parse() {
        this.parseName(this.doc);
        this.parseType(this.doc);
        this.parseStructure(this.doc);
        this.parseData(this.doc);
        this.parseWhenExpression(this.doc);
        return new CompatibilityTableFactory(this.name, this.type, this.structure, this.data, this.whenExpression);
    }
    parseName(doc) {
        if ('_id' in doc) {
            this.name = doc._id;
        }
        else {
            throw new TypeError(`CompatibilityTable. Missing '_id' field`);
        }
    }
    parseType(doc) {
        if ('type' in doc && typeof doc.type === 'string') {
            this.type = doc.type;
        }
        else {
            throw new TypeError(`CompatibilityTable ${this.name}. Missing 'type' field`);
        }
    }
    parseData(doc) {
        if ('data' in doc && Array.isArray(doc.data)) {
            for (let row of doc.data) {
                this.parseRow(row);
            }
        }
        else {
            throw new TypeError(`CompatibilityTable ${this.name}. Field 'data' should be a list of rules`);
        }
    }
    parseRow(row) {
        if (Array.isArray(row) && row.length === this.structure.columns.length) {
            this.data.push(row);
        }
        else {
            throw new TypeError(`CompatibilityTable ${this.name}. Rule should be a list of ${this.structure.columns.length} elements`);
        }
    }
    parseStructure(doc) {
        if ('order' in doc) {
            if (Array.isArray(doc.order)) {
                this.structure = {
                    columns: doc.order.map(String)
                };
            }
            else {
                throw new TypeError(`CompatibilityTable ${this.name}. Field 'order' should be a list of property names`);
            }
        }
        else {
            throw new TypeError(`CompatibilityTable ${this.name}. Field 'order' is missing`);
        }
    }
    parseWhenExpression(doc) {
        if ('when' in doc) {
            const func = new Function('root, data', doc.when);
            this.whenExpression = (model) => func(model, this.data);
        }
        else {
            this.whenExpression = () => true;
        }
    }
}
//# sourceMappingURL=CompatibilityTableParser.js.map